import type {
  TEmailBuilderActivePanel,
  TEmailBuilderEditingMode,
} from "redux/reducers/emailBuilder/emailBuilder";

export type TEmailBuilderDesignEscapeAction =
  | "none"
  | "close-inline-content"
  | "close-chrome"
  | "close-toolbar"
  | "close-settings"
  | "clear-blocks";

export function emailBuilderToolbarPanelIsOpen(args: {
  activePanel: TEmailBuilderActivePanel;
  usesBottomSheetChrome: boolean;
  mobileToolbarOpen: boolean;
}): boolean {
  if (args.usesBottomSheetChrome) {
    return args.mobileToolbarOpen;
  }

  return args.activePanel !== "none";
}

export function shouldIgnoreEmailBuilderDesignEscapeTarget(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) {
    return false;
  }

  if (
    target.closest(".email-builder-merge-tag-autocomplete") !== null ||
    target.closest(".email-builder-text-link-popover") !== null ||
    target.closest(".color-picker-popup") !== null ||
    target.closest("[data-email-builder-field-merge-tag-popover]") !== null ||
    target.closest(".modal.show") !== null ||
    target.closest(".ui-popup_container--open") !== null
  ) {
    return true;
  }

  const inlineEditor =
    target.closest("[data-email-builder-inline-text]") ??
    target.closest("[data-email-builder-inline-button-label]");
  if (
    inlineEditor instanceof HTMLElement &&
    inlineEditor.getAttribute("aria-expanded") === "true"
  ) {
    return true;
  }

  return false;
}

export function resolveEmailBuilderDesignEscapeAction(args: {
  editingMode: TEmailBuilderEditingMode;
  activePanel: TEmailBuilderActivePanel;
  usesBottomSheetChrome: boolean;
  mobileToolbarOpen: boolean;
  hasCanvasSelection: boolean;
}): TEmailBuilderDesignEscapeAction {
  if (args.editingMode === "inline-content") {
    return "close-inline-content";
  }

  const toolbarOpen = emailBuilderToolbarPanelIsOpen(args);
  const settingsOpen = args.editingMode === "block-settings";

  if (toolbarOpen && settingsOpen) {
    return "close-chrome";
  }

  if (toolbarOpen) {
    return "close-toolbar";
  }

  if (settingsOpen) {
    return "close-settings";
  }

  if (args.hasCanvasSelection) {
    return "clear-blocks";
  }

  return "none";
}
